<template>
        <div class="row h-100">
            <div class="col col-3 h-100" style="overflow:auto">
                <a href="#" class="customer-row" @click="onClickCustomer(customer)" v-for="customer in customerOfCountry" :key="customer.id">{{customer.data.shortname}}</a>
            </div>
            <div class="col col-9 h-100">

                <div ref="chartdiv" style="height:100%; width:100%;" >
                </div>

            </div>
        </div>
</template>

<script>
import Vue from 'vue'
import * as am4core from '@amcharts/amcharts4/core'
import * as am4maps from '@amcharts/amcharts4/maps'
import am4geodataWorldLow from '@amcharts/amcharts4-geodata/worldLow'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('customer')

export default {
    name: 'CustomerMap',
    data: function () {
        return {
            customerOfCountry: []
        }
    },
    async mounted () {
        let map = am4core.create(this.$refs.chartdiv, am4maps.MapChart)
        map.geodata = am4geodataWorldLow
        map.panBehavior = 'rotateLongLat'
        map.zoomControl = new am4maps.ZoomControl()
        map.zoomControl.slider.height = 100
        map.projection = new am4maps.projections.Miller()
        let polygonSeries = map.series.push(new am4maps.MapPolygonSeries())
        polygonSeries.useGeodata = true

        let polygonTemplate = polygonSeries.mapPolygons.template
        polygonTemplate.tooltipText = '{name}'
        polygonTemplate.fill = am4core.color('#BBB')

        // Create hover state and set alternative fill color
        let hs = polygonTemplate.states.create('hover')
        hs.properties.fill = am4core.color('#900')

        polygonSeries.exclude = ['AQ']

        polygonTemplate.events.on('hit', this.getCustomerOfCountry)

        let countryResult = await Vue.API.AmfRequest(
            'AddressController',
            'getCountriesForMap'
        )

        polygonSeries.data = countryResult.data.map
        polygonTemplate.propertyFields.fill = 'fill'
    },
    methods: {
        async getCustomerOfCountry (ev) {
            var data = ev.target.dataItem.dataContext
            let customerResult = await Vue.API.AmfRequest(
                'frechmann.Customer',
                'getCustomerOfGeoId',
                data.geo_id
            )
            this.customerOfCountry = customerResult.data
        },
        ...mapActions([
            'setSelectedCustomer'
        ]),
        onClickCustomer (customer) {

            this.setSelectedCustomer(customer);

            this.$emit('on-customer-select', customer)
        }
    }
}
</script>

<style scoped>
.customer-row {
    display:inline-block;
    width:33%;
    padding:0.5em;
    color:#FFF;
    border-bottom:solid #000 1px;
    border-right:solid #000 1px;
    background-color:#333;
}
.customer-row:hover {
    background-color:#900;

}
</style>
